import { notification } from 'antd';
import { ArgsProps, NotificationInstance } from 'antd/lib/notification';

const getSafeArgs = (args: ArgsProps) => ({
  ...args,
  description: <div dangerouslySetInnerHTML={{ __html: args.description as string }} />,
});

export const notificationDesSafe: NotificationInstance = {
  success: (args: ArgsProps) => notification.success(getSafeArgs(args)),
  error: (args: ArgsProps) => notification.error(getSafeArgs(args)),
  info: (args: ArgsProps) => notification.info(getSafeArgs(args)),
  warning: (args: ArgsProps) => notification.warning(getSafeArgs(args)),
  open: (args: ArgsProps) => notification.open(getSafeArgs(args)),
};

export const notificationDefaultError = (description?: string) =>
  notification.error({
    message: 'Error',
    description: description ? (
      <div dangerouslySetInnerHTML={{ __html: description }} />
    ) : (
      <div>
        Something is not quite right, please contact <a href="mailto:support@32co.com">support@32co.com</a> for help
      </div>
    ),
    placement: 'topRight',
  });

export const notificationApiError = (error: any) => {
  error?.data?.errors?.forEach((err: any) => {
    notificationDesSafe.error({
      message: 'Error',
      description: err.message,
      placement: 'topRight',
    });
  });
};

export const LOCALSTORAGE_KEY = {
  TABLE: {
    PRIORITY_CASES: {
      PAGE_SIZE: 'TABLE.PRIORITY_CASES.PAGE_SIZE',
    },
  },
};

export const ZINDEX = {
  NO_CONECTION: 2500,
  DEBUG_OVERLAY: 2000,
  JOYRIDE: 1000, // should > 999
  CHAT_CONTAINER: 270,
  LAYOUT_HEADER: 250,
  PAGE_OVERLAY_LOADER: 200,
  SAVE_AS_DRAFT_BTN: 90,
  SUBMIT_TREATMENT_CHECKIN: 9,
};

export const BREAKPOINT = {
  SM: 576,
  MD: 768,
  LG: 992,
};

export const toogleBodyElmScrollClosure = () => {
  const initialMainHeaderElmPaddingRight = parseInt(
    document.getElementById('MAIN_HEADER_ID')?.style?.paddingRight ?? '0',
    10,
  );
  const initialChatToolElmRight = parseInt(document.getElementById('CHAT_TOOL')?.style?.right ?? '0', 10);

  return (enabled: boolean) => {
    const offset = window.innerWidth - document.body.offsetWidth;
    const mainHeaderElm = document.getElementById('MAIN_HEADER_ID');
    const chatToolElm = document.getElementById('CHAT_TOOL');

    if (enabled) {
      if (mainHeaderElm) mainHeaderElm.style!.paddingRight = `${initialMainHeaderElmPaddingRight}px`;
      if (chatToolElm) chatToolElm.style!.right = `${initialChatToolElmRight}px`;
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '0px';
    } else {
      if (mainHeaderElm) mainHeaderElm.style!.paddingRight = `${offset}px`;
      if (chatToolElm) chatToolElm.style!.right = `${parseInt(chatToolElm.style!.right, 10) + offset}px`;
      document.body.style.paddingRight = `${offset}px`;
      document.body.style.overflow = 'hidden';
    }
  };
};

export const toogleBodyElmScroll = toogleBodyElmScrollClosure();
